import { getApiKey } from "../../utils/apiKey";
import Header from "../header";
import "../../style/Profile/wallet.css";
import { useEffect, useState } from "react";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import persian from "react-date-object/calendars/persian";
import persian_en from "react-date-object/locales/persian_en";
import { toast } from "react-hot-toast";
import PulseLoader from "react-spinners/PulseLoader";
import CustomDatePicker from "../global/DatePicker";
export const apiCall_domainV2 = "https://xyz.kacharlife.com/api/v2";

const Wallet = () => {
  const [isLoading, setLoading] = useState(true);
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);
  const [isDepositModalOpen, setIsDepositModalOpen] = useState(false);
  const [isFilterModalOpen, setisFilterModalOpen] = useState(false);
  const [walletLog, setWalletLog] = useState([]);
  const [moneyAmount, setMoneyAmount] = useState("");
  const [logModalData, setLogModalData] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [type, setType] = useState("");
  const [monthsPeriod, setMonthsPeriod] = useState("");
  const [threeMonthsPeriod, setThreeMonthsPeriod] = useState("");
  const [year, setYear] = useState("");
  const [withdrawLoader, setwithdrawLoader] = useState(false);
  // const [dateFormat, setDateFormat] = useState({ format: "YYYY/MM/DD" });

  // const convert = (date, format = dateFormat.format) => {
  //   let object = { date, format };
  //   setDateFormat({
  //     persian: new DateObject(object).convert(persian, persian_en).format(),
  //     jsDate: date.toDate(),
  //     ...object,
  //   });
  // }

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${apiCall_domainV2}/customer/wallets?
        ${type ? `type=${type}&` : ""}${
          startDate ? `startDate=${startDate}&` : ""
        }${endDate ? `endDate=${endDate}&` : ""}${
          monthsPeriod ? `monthsPeriod=${monthsPeriod}&` : ""
        }${threeMonthsPeriod ? `threeMonthsPeriod=${threeMonthsPeriod}&` : ""}${
          year ? `year=${year}&` : ""
        }`,
        {
          headers: headers,
        },
      )
      .then((res) => setWalletLog(res.data.data.index))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, monthsPeriod, threeMonthsPeriod, year]);

  const headers = {
    Authorization: getApiKey(),
    "content-type": "application/json",
  };

  const toggleDropdown = () => {
    const dropdownMenu = document.querySelector(".dropdown-menu");
    dropdownMenu.style.display =
      dropdownMenu.style.display === "none" ? "block" : "none";
  };

  const openLogModal = (data) => {
    setIsLogModalOpen(true);
    setLogModalData(data);
  };

  const openDepositModal = () => {
    setIsDepositModalOpen(true);
    setMoneyAmount(null);
  };

  const closeModal = () => {
    setIsLogModalOpen(false);
    setIsDepositModalOpen(false);
  };

  const handleMoneyAmount = (value) => {
    if (value !== null) {
      setMoneyAmount(value);
    } else setMoneyAmount(null);
  };

  const filterLog = (type) => {
    setType(type);
    setLoading(true);
    toggleDropdown();
  };

  const setPeriod = (period) => {
    if (period === "monthsPeriod") {
      setMonthsPeriod("months");
      setThreeMonthsPeriod("");
      setYear("");
    }
    if (period === "threeMonthsPeriod") {
      setMonthsPeriod("");
      setThreeMonthsPeriod("months");
      setYear("");
    }
    if (period === "year") {
      setMonthsPeriod("");
      setThreeMonthsPeriod("");
      setYear("year");
    }
    setLoading(true);
  };

  const submitWithdraw = () => {
    setwithdrawLoader(true);
    axios
      .post(
        `${apiCall_domainV2}/customer/wallets/WithdrawalAccount`,
        {},
        {
          headers: headers,
          dev_type: 3,
        },
      )
      .then((res) => toast.success("برداشت با موفقیت انجام شد"))
      .catch((err) => toast.error(err?.response?.data?.error))
      .finally(() => setwithdrawLoader(false));
  };

  const submitDeposit = () => {
    axios
      .post(
        `${apiCall_domainV2}/customer/wallets/recharge`,
        {
          amount: moneyAmount,
          pay_type: 1,
          dev_type: 3,
        },
        {
          headers: headers,
        },
      )
      .then((res) => window.location.replace(res.data.pay_details.url))
      .catch((err) => {
        toast.error(err?.response?.data?.error);
      })
      .finally(() => handleMoneyAmount(0));
  };

  const submitFilters = () => {
    setLoading(true);
    axios
      .get(
        `${apiCall_domainV2}/customer/wallets?${type ? `type=${type}&` : ""}${
          startDate ? `startDate=${startDate}&` : ""
        }${endDate ? `endDate=${endDate}&` : ""}${
          monthsPeriod ? `monthsPeriod=${monthsPeriod}&` : ""
        }${threeMonthsPeriod ? `threeMonthsPeriod=${threeMonthsPeriod}&` : ""}${
          year ? `year=${year}` : ""
        }`,
        {
          headers: headers,
        },
      )
      .then((res) => setWalletLog(res.data.data.index))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Header
        showSearchBar={true}
        title={"کیف پول"}
        isDarkTheme={false}
        backUrl={"/profile"}
      />
      <div className="walletContainer">
        <div className="walletHeader">
          <div className="userCurrency">
            <div>
              <img src="/public/assets/img/profile/wallet.svg" />
              <span>موجودی کیف پول شما</span>
            </div>
            <span className="currency">{} تومان</span>
          </div>
          <div className="recommendedCurrency">
            <span>موجودی مناسب برای خرید از کاچار</span>
            <span className="currency">{} تومان</span>
          </div>
          <div className="walletTransfer">
            {withdrawLoader ? (
              <button className="withdrawBtn">
                <PulseLoader color="#fff" size={12} />
              </button>
            ) : (
              <button className="withdrawBtn" onClick={submitWithdraw}>
                برداشت موجودی کیف پول
              </button>
            )}
            <button className="depositBtn" onClick={openDepositModal}>
              شارژ کیف پول
            </button>
          </div>
        </div>
      </div>
      <div className="walletBody">
        <h4 className="title">جزئیات تراکنش ها</h4>
        <div className="filtersBar">
          <div className="dropdown filters">
            <div className="dropdown-toggle" onClick={toggleDropdown}>
              <i className="icon-filters" />
              <span>فیلتر بندی</span>
            </div>
            <div className="dropdown-menu">
              <div className="dropdown-item" onClick={() => filterLog(-1)}>
                پرداختی
              </div>
              <div className="dropdown-item" onClick={() => filterLog(1)}>
                دریافتی
              </div>
            </div>
          </div>
          <div className="dropdown filters orderBy">
            <div onClick={() => setisFilterModalOpen(true)}>
              <i className="icon-order" />
              <span>بر اساس</span>
            </div>
            <i className="icon-chevron-down chevron" />
          </div>
        </div>
        <div className="walletLogs">
          {isLoading ? (
            <Spinner />
          ) : walletLog.length !== 0 ? (
            <>
              {walletLog.map((data) => (
                <div onClick={() => openLogModal(data)} className="walletLog">
                  <span>
                    {data?.id} {data?.operation}{" "}
                    {data.order_id !== null || data.orderable
                      ? `${data.orderable} ${data.order_id}`
                      : ""}
                  </span>
                  <div>
                    <span className={data.type === 1 ? `green` : `red`}>
                      {data.amount.toLocaleString()}
                    </span>{" "}
                    تومان
                  </div>
                  <span>{data.created_at}</span>
                </div>
              ))}
            </>
          ) : (
            <>
              <div className="noLog">
                <img src="/public/assets/img/profile/walletdisabled.svg" />
                <span>تراکنشی ثبت نشده است</span>
              </div>
            </>
          )}
        </div>

        {isLogModalOpen && (
          <div className="modal">
            <div className="historyModalContent">
              <div className="modalHeader">
                <span>ریز جزئیات</span>
                <span className={logModalData.type === 1 ? "green" : "red"}>
                  {logModalData.operation}
                </span>
              </div>
              <p>
                مبلغ {logModalData.amount.toLocaleString()} تومان بابت{" "}
                {logModalData?.details?.description}
                <span> سفارش {logModalData?.details?.order_id} </span> در تاریخ{" "}
                <span>{logModalData?.created_at}</span> به کیف پول شما{" "}
                <span className={logModalData.type === 1 ? "green" : "red"}>
                  {logModalData.operation}
                </span>{" "}
                شده است{" "}
              </p>
              <span className="trackCode">
                {" "}
                کد پیگیری: {logModalData?.transaction_id}
              </span>
              <span className="modalClose" onClick={closeModal}>
                بستن
              </span>
            </div>
          </div>
        )}
        {isDepositModalOpen && (
          <div className="modal">
            <div className="depositModalBody">
              <div className="depositModalContent">
                <div className="modalTitle">
                  <h4>کیف پول خود را شارژ کنید</h4>
                  <i
                    className="icon-times"
                    onClick={() => setIsDepositModalOpen(false)}
                  />
                </div>
                <p>
                  تذکر کف شارژ کیف پول به صورت روزانه از 10.000 تومان تا
                  10.000.000 تومان می باشد
                </p>
                <input
                  placeholder="مبلغ را وارد کنید"
                  value={moneyAmount}
                  onClick={() => handleMoneyAmount(0)}
                  onChange={(e) => handleMoneyAmount(+e.target.value)}
                />
                <div className="sumptionBtns">
                  <div className="sumptionBtns">
                    <button onClick={() => handleMoneyAmount(10000)}>
                      10,000 <span>تومان</span>
                    </button>
                    <button onClick={() => handleMoneyAmount(100000)}>
                      100,000 <span>تومان</span>
                    </button>
                    <button onClick={() => handleMoneyAmount(200000)}>
                      200,000 <span>تومان</span>
                    </button>
                    <button onClick={() => handleMoneyAmount(500000)}>
                      500,000 <span>تومان</span>
                    </button>
                    <button onClick={() => handleMoneyAmount(1000000)}>
                      1,000,000 <span>تومان</span>
                    </button>
                    <button onClick={() => handleMoneyAmount(10000000)}>
                      10,000,000 <span>تومان</span>
                    </button>
                  </div>
                </div>
              </div>
              <button
                className="modalClose"
                onClick={() => {
                  submitDeposit();
                  setIsDepositModalOpen(false);
                }}
              >
                پرداخت
              </button>
            </div>
          </div>
        )}
        {isFilterModalOpen && (
          <div className="modal">
            <div className="filterModalContent">
              <h4>بر اساس</h4>
              <div className="sumptionBtns">
                <div>بازه زمانی</div>
                <button onClick={() => setPeriod("monthsPeriod")}>
                  1 ماهه
                </button>
                <button onClick={() => setPeriod("threeMonthsPeriod")}>
                  3 ماهه
                </button>
                <button onClick={() => setPeriod("year")}>1 ساله</button>
              </div>
              <div className="dateSection">
                <div className="date">
                  <span>از تاریخ</span>
                  <CustomDatePicker
                    onChange={(e) => setStartDate(e)}
                    style={{
                      width: "100%",
                      border: "none",
                      backgroundColor: "#F0F0F0",
                      padding: "1.25rem 1rem",
                    }}
                    calendar={persian}
                    locale={persian_en}
                    format="YYYY/MM/DD"
                  />
                </div>
                <div className="date">
                  <span>تا تاریخ</span>
                  <CustomDatePicker
                    onChange={(e) => setEndDate(e)}
                    style={{
                      width: "100%",
                      border: "none",
                      backgroundColor: "#F0F0F0",
                      padding: "1.25rem 1rem",
                    }}
                    calendar={persian}
                    locale={persian_en}
                    format="YYYY/MM/DD"
                  />
                </div>
              </div>
              <span
                className="modalClose"
                onClick={() => {
                  setisFilterModalOpen(false);
                  submitFilters();
                }}
              >
                بستن
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default Wallet;
